<template>
  <div class="manage-category">
    <el-row type="flex" align="middle" justify="space-between" class="mb-l">
      <el-row type="flex" align="middle" class="page-title">
        <i class="el-icon-menu mr-s" />
        <h3>Quản lý danh mục bài viết</h3>
      </el-row>
      <el-button
        type="primary"
        @click="$router.push({ name: 'CreateCategory' })"
      >
        Thêm
      </el-button>
    </el-row>
    <el-input
      v-model="name"
      @input="handleSearchCategory"
      clearable
      placeholder="Tìm kiếm danh mục"
      class="search mb-xl"
    />
    <el-row type="flex" justify="end">
      <el-button
        size="medium"
        type="primary"
        class="mb-m"
        @click="handleRefreshData"
      >
        <i class="el-icon-refresh"></i>
      </el-button>
    </el-row>
    <el-table
      :data="categories"
      border
      v-loading="callingAPI"
      row-key="id"
      default-expand-all
    >
      <el-table-column label="Tên">
        <template slot-scope="scope"> {{ scope.row.name }} </template>
      </el-table-column>
      <el-table-column label="Mô tả">
        <template slot-scope="scope"> {{ scope.row.description }} </template>
      </el-table-column>
      <el-table-column label="Ngày tạo" width="120px">
        <template slot-scope="scope">
          {{ scope.row.created_at | convertDate }}
        </template>
      </el-table-column>
      <el-table-column label="Loại" width="120px">
        <template slot-scope="scope">
          {{ scope.row.parent_id ? "Topic" : "Category" }}
        </template>
      </el-table-column>
      <el-table-column width="50px" align="center">
        <template slot-scope="scope">
          <el-dropdown trigger="click">
            <i class="el-icon-more cursor-pointer"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-if="!scope.row.parent_id"
                @click.native="showCreateTopic(scope.row)"
                icon="el-icon-plus"
              >
                Tạo topic
              </el-dropdown-item>
              <el-dropdown-item
                icon="el-icon-edit"
                @click.native="handleUpdate(scope.row)"
              >
                {{ scope.row.parent_id ? "Sửa topic" : "Sửa category" }}
              </el-dropdown-item>
              <el-dropdown-item
                @click.native="handeRemoveCategory(scope.row)"
                divided
                class="text-danger"
                icon="el-icon-delete-solid"
              >
                Xoá
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-row type="flex" justify="end" class="mt-m">
      <el-pagination
        background
        layout="prev, pager, next"
        :disabled="callingAPI"
        @current-change="handleChangePage"
        :currentPage="page"
        :pageSize="pageSize"
        :total="total"
      />
    </el-row>

    <manage-topic
      :visible="visibleCreateTopic"
      :category="selectedCategory"
      :currentTopic="null"
      @close="loadData(page)"
    />
    <manage-topic
      :visible="visibleUpdateTopic"
      :category="selectedCategory"
      :currentTopic="selectedTopic"
      @close="loadData(page)"
    />
  </div>
</template>

<script>
import { searchCategory, deleteCategory } from "@/services/category";
import ManageTopic from "./popup/ManageTopic";
export default {
  name: "ManageCategory",
  components: {
    ManageTopic,
  },
  data() {
    return {
      callingAPI: false,
      debounce: null,

      name: "",
      page: 1,
      pageSize: 10,
      total: 0,

      categories: [],

      selectedCategory: {},
      selectedTopic: {},
      visibleCreateTopic: false,
      visibleUpdateTopic: false,
    };
  },
  async beforeMount() {
    await this.loadData();
  },
  methods: {
    async handleRefreshData() {
      this.name = "";
      await this.loadData();
    },
    async loadData(page = null) {
      try {
        this.visibleCreateTopic = false;
        this.visibleUpdateTopic = false;
        this.callingAPI = true;
        const params = {
          name: this.name,
          page: page ? page : 1,
          limit: this.pageSize,
          parent_id: null,
        };
        const response = await searchCategory(params);
        this.categories = response.data.categories.map((c) => ({
          ...c,
          children: c.child_category,
        }));
        this.total = response.data.paginate.total;
        this.callingAPI = false;
      } catch (error) {
        console.log(error);
        this.callingAPI = false;
      }
    },

    async handleChangePage(page) {
      this.page = page;
      await this.loadData(page);
    },

    async handleSearchCategory() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(async () => {
        await this.loadData();
      }, 500);
    },

    async loadTopic(tree, treeNode, resolve) {
      resolve(tree.child_category);
    },

    async handeRemoveCategory(row) {
      this.$confirm(`Chắc chắn muốn xoá ${row.name} ?`, "Warning", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      })
        .then(async () => {
          try {
            this.callingAPI = true;
            const response = await deleteCategory(row.id);
            if (response.message) {
              this.callingAPI = false;
              this.$notify.error({
                title: "Thất bại",
                message: response.message,
                duration: 2000,
              });
              return;
            }
            await this.loadData(this.page);
            this.$notify.success({
              title: "Thành công",
              message: `Xoá ${row.name} thành công.`,
              duration: 2000,
            });
          } catch (error) {
            this.callingAPI = false;
            this.$notify.error({
              title: "Thất bại",
              message: "Xoá thất bại.",
              duration: 2000,
            });
          }
        })
        .catch(() => {});
    },

    showCreateTopic(row) {
      this.selectedCategory = row;
      this.visibleCreateTopic = true;
    },

    handleUpdate(row) {
      if (row.parent_id) {
        this.selectedCategory = this.categories.find(
          (c) => c.id === row.parent_id
        );
        this.selectedTopic = row;
        this.visibleUpdateTopic = true;
      } else {
        this.$router.push({
          name: "UpdateCategory",
          params: { id: row.id },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0;
}
</style>
